import React, { useState } from "react";
import { AppPage, MimaButton, PageLoader, Searchbar, } from "../../components";
import MimaOptionMenu from '../../components/OptionMenu/';
import { AnimatePresence } from "framer-motion";
import { AddAdminContainer, EditAdminContainer, RevokeAdminContainer } from "../../containers";


const Admin = ({
    goToEdit,
    admins,    
    setLoading,
    loading,   
    handleEdit,
    handleRevoke,
    closeModal,
    goToRevoke,
    onSubmit,
    handleAdd,
    goToAdd }) => {
    const [filteredItems, setFilteredItems] = useState([]);
    const [data, setData] = useState({});

    const adminUsers = admins.admins;

    return (
        <AppPage pageTitle="Admin Control">

            {loading ? (
                <PageLoader title="while we load your information" />
            ) : (
                <div style={{ marginTop: "2rem" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: "7rem" }}>
                        <Searchbar
                            variant="wide"
                            placeholder="Search"
                            input={adminUsers}
                            output={setFilteredItems}
                            handleFilter={(item, searchQuery) => {
                                return item?.firstname.toLowerCase()?.includes(searchQuery) ||
                                    item?.lastname.toLowerCase()?.includes(searchQuery) ||
                                    item?.email.toLowerCase()?.includes(searchQuery) ||
                                    item?.status.toLowerCase()?.includes(searchQuery)
                            }}
                        />
                        <MimaButton
                            title="Add Admin"
                            width={30}
                            onClick={handleAdd}

                        />
                    </div>

                    <div className='whiteTable'>
                        <table>
                            <thead>
                                <tr>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Email Address</th>
                                    <th>Mobile</th>
                                    <th>Role</th>
                                    <th><div className='status__th'>Status</div></th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredItems.map((item) => (
                                    <tr key={item._id}>
                                        <td>{item.firstname}</td>
                                        <td>{item.lastname}</td>
                                        <td>{item.email}</td>
                                        <td>{item.mobile}</td>
                                        <td>{item.role.name}</td>
                                        <td>
                                            <div className={`status ${item.status === "ACTIVE" ? 'status__green' : 'status__red'}`}>{item.status}</div>
                                        </td>
                                        <td>
                                            <div className='tableAction__text'>
                                                <MimaOptionMenu
                                                    options={[
                                                        {
                                                            label: item.status === "ACTIVE" ? "Revoke Permission" : "Reactivate",
                                                            value: "REVOKE"
                                                        },
                                                        {
                                                            label: item.permissions.length === 0 ? "Add Permission" : "Edit Permission",
                                                            value: "EDIT"
                                                        }
                                                    ]}
                                                    onOptionSelected={option => {
                                                        setData(item);
                                                        if (option.value === "REVOKE") {
                                                            handleRevoke(item._id);
                                                        } else if (option.value === "EDIT") {
                                                            handleEdit();
                                                        }
                                                    }}
                                                />

                                            </div>
                                        </td>

                                    </tr>
                                ))}



                            </tbody>
                        </table>
                    </div>
                    {(goToRevoke || goToAdd || goToEdit) && (
                        <di className="modal">
                            <AnimatePresence>
                                {goToRevoke &&
                                    <RevokeAdminContainer
                                        data={data}
                                        onSubmit={onSubmit}
                                        closeModal={closeModal}
                                        setLoading={setLoading}
                                        loading={loading}
                                    />}

                                {goToAdd &&
                                    <AddAdminContainer
                                        data={data}                                       
                                        closeModal={closeModal}
                                    />
                                }

                                {goToEdit &&
                                    <EditAdminContainer
                                        data={data}
                                        closeModal={closeModal}
                                    />
                                }
                            </AnimatePresence>
                        </di>

                    )}
                </div>

            )}

        </AppPage>
    )
}

export default Admin;